import BaseComponent from "../../../base/common/BaseComponent";

export default class Home extends BaseComponent {
  render() {
    return <div>home</div>;
  }
}
